import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SocialInfo.css";
import socialImg from '../../assets/social-info.jpg';

const SocialInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row>
          <Col xs={12} lg={8} className="slide-in-left mb-4 mb-lg-0">
            <h1 className="text-primary2 fw-bold mb-4 text-center text-lg-start">Artist Management</h1>
            
            <Row className="align-items-center">
              <Col xs={12} md={6} className="mb-3 mb-md-0 text-center">
                <img
                  src={socialImg}
                  alt="Social Events"
                  className="img-fluid company-image"
                />
              </Col>

              <Col xs={12} md={6} className="text-white">
                <h4 className="text-white mt-4 mt-md-0 mb-3">Artist Management</h4>
                <ul className="event-services-list ps-3">
                  <li>Birthday Parties</li>
                  <li>Wedding Ceremonies</li>
                  <li>Engagement Parties</li>
                  <li>Anniversary Celebrations</li>
                  <li>Baby Showers</li>
                  <li>Graduation Parties</li>
                  <li>Retirement Parties</li>
                  <li>Family Reunions</li>
                </ul>
              </Col>
            </Row>

            <p className="text-white mt-4">
              Zarinova Entertainment is your premier choice for unforgettable social events. Specializing in creating unique and memorable experiences, we bring your vision to life with impeccable attention to detail. Whether you're planning an intimate gathering, a lavish wedding, or a corporate gala, our team of skilled professionals is dedicated to ensuring every aspect of your event is flawless. At Zarinova Entertainment, we pride ourselves on our creativity, innovation, and commitment to excellence. Our comprehensive services include event planning, coordination, design, and entertainment, tailored to meet your specific needs and preferences.
            </p>
          </Col>

          <Col xs={12} lg={4} className="slide-in-right">
            <Card className="get-in-touch-card">
              <Card.Body>
                <h5 className="fw-bold text-white">GET IN TOUCH</h5>
                <p className="small text-white">PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION</p>

                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="YOUR COMMENT"
                    />
                  </Form.Group>

                  <Button
                    variant="warning1"
                    className="learn-more-btn rounded-pill px-4 py-2 text-white w-100"
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SocialInfo;
